import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onCloseModal: () => void
}

const Footer = ({ onCloseModal }: Props) => {
  return (
    <>
      <Button disabled={false} onClick={onCloseModal} type="secondary">
        {i18n.t('common.cancel')}
      </Button>
      <Button submit>
        {i18n.t('contract_versions.flows.update.steps.role_level_salary.policy.confirm_delete')}
      </Button>
    </>
  )
}

export default observer(Footer)
